"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = markRegExp;

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Replaces matching patterns in a string with markers.
 *
 * @param {string} content The content to parse and mark.
 *
 * @param {RegExp} rule The pattern to search and replace in the content.
 *
 * @param {Function} tag A function that takes the match string and must return
 * a React component or a string. The value returned by that function will
 * replace the term in the output.
 *
 * @param {number} matchIndex The index of the match to use when marking with
 * a RegExp. If not provided, will use the last non-null match available.
 *
 * @returns {React.ReactNodeArray} A ReactNodeArray of strings and components,
 * similar to the original content but where each matching pattern has been
 * replaced by a marking component.
 */
function markRegExp(content, rule, tag, matchIndex) {
  var output = [];
  var remaining = content;
  var matches = rule.exec(remaining);

  while (matches) {
    var match = void 0;

    if (typeof matchIndex !== 'undefined' && matchIndex !== null) {
      match = matches[matchIndex];
    } else {
      // Use the last non-null matching form. This is to support several
      // capture groups in the rule.
      match = matches.reduce(function (acc, cur) {
        return cur || acc;
      }, '');
    } // Take only the part that can contain the match.


    var matchingContent = remaining.slice(matches.index); // Then split only that part.

    var _matchingContent$spli = matchingContent.split(match),
        _matchingContent$spli2 = _toArray(_matchingContent$spli),
        previous = _matchingContent$spli2[0],
        rest = _matchingContent$spli2.slice(1); // Reconstruct everything before the match.


    var beginning = remaining.slice(0, matches.index);

    if (previous) {
      beginning += previous;
    } // Reconstruct everything after the match.


    remaining = remaining.slice(beginning.length + match.length); // Add the parts that have been parsed to the output.

    if (beginning) {
      output.push(beginning);
    }

    output.push(tag(match)); // Compute the next step.

    matches = rule.exec(remaining);
  }

  if (remaining) {
    output.push(remaining);
  }

  return output;
}